'use client';

import { useState, useLayoutEffect } from 'react';

export const useIsBelowScreenWidth = (
  width: number,
  callback?: (isBelow: boolean) => void,
): boolean | null => {
  const [isBelow, setIsBelow] = useState<boolean>(false);

  const [mounted, setMounted] = useState(false);

  useLayoutEffect(() => {
    const checkScreenWidth = () => {
      const isBelowValue = window.innerWidth < width;

      setIsBelow(isBelowValue);

      setMounted(true);

      if (callback) {
        // for cases when we want to trigger an action right after the screen width check (show single unavailable asset notification on asset details for desktop)
        callback(isBelowValue);
      }
    };

    // Initial check
    checkScreenWidth();

    // Add event listener
    window.addEventListener('resize', checkScreenWidth);

    // Cleanup event listener
    return () => {
      window.removeEventListener('resize', checkScreenWidth);
    };
  }, [width]);

  return mounted ? isBelow : null;
};
